export default __webpack_public_path__ + "static/media/banque.5fc88054.png";